import { render, staticRenderFns } from "./Photo.vue?vue&type=template&id=7faf3b2e&"
import script from "./Photo.vue?vue&type=script&lang=js&"
export * from "./Photo.vue?vue&type=script&lang=js&"
import style0 from "./Photo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports